<li class="govuk-!-margin-bottom-3 govuk__flex govuk__justify-content-space-between">
  <div>
    <ng-content></ng-content>
  </div>
  <div class="govuk-!-margin-left-2">
    <img src="/assets/images/small_blue_arrow.svg" alt="" />
  </div>
</li>
